import api from './interceptor';

const BASE_URL_V3 = 'api/v3/departments';

export default {
  // API Version 3
  getDepartments: params => api.get(`${BASE_URL_V3}`, { params }),
};
